import authService from '../../services/authService';
import userService from '../../services/userService';
import utilsService from '../../services/utilsService';
import axios from 'axios';

// initial state
const state = {
  user:{},
  token: localStorage.getItem('token') || '',
  status:'',
  favorites: {},
  favoriteIds:[]
}

// getters
const getters = {
  isLoggedIn: state => !!(state.token && state.user)
}

// actions
const actions = {
  login (context, params) {
    // return authService.login(params);
    return new Promise((resolve,reject)=>{
      authService.login(params)
      .then((resp) => {
        localStorage.setItem('token', resp.data.token)
        axios.defaults.headers.common['Authorization'] = `Bearer ${resp.data.token}`
        context.commit('auth_success', resp.data)
        resolve(resp)
      })
      .catch(err => {
        context.commit('auth_error')
        localStorage.removeItem('token')
        reject(err)
      })
    })
  },
  getMe(context,params){
    if (localStorage.getItem('token')) {
      return new Promise((resolve, reject) => {
        authService.getMe(params)
        .then((resp) => {
          resolve(resp)
          context.commit('set_user',resp.data)
        })
        .catch(err => {
          reject(err)
          localStorage.removeItem('token')
          context.commit('logout')
        })
      })
     
    }
  },
  logout(context) {
    return new Promise((resolve) => {
      authService.logout()
      .then(resp => {
        context.commit('logout')
        localStorage.removeItem('token')
        delete axios.defaults.headers.common['Authorization']
        resolve(resp)
      })
    })
  },
  favorites(context,params){
    return new Promise((resolve, reject) => {
        userService.getFavorites(params)
        .then(resp => {
          context.commit('set_favorites',resp.data)
          resolve(resp.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  register(context, params){
      return new Promise((resolve, reject) => {
        authService.register(params)
          .then(resp => {
            resolve(resp.data)
          })
          .catch(err => {
            reject(err.response.data)
          })
      })
  },
  sendResetPasswordMail(context, params){
      return new Promise((resolve, reject) => {
        authService.sentResetMail(params)
          .then(resp => {
            resolve(resp.data)
          })
          .catch(err => {
            reject(err.response.data)
          })
      })
  },
  resetPassword(context, params) {
      return new Promise((resolve, reject) => {
          authService.resetPassword(params)
          .then(resp => {
              resolve(resp.data)
          })
          .catch(err => {
              reject(err.response.data)
          })
      })
  },
  updateProfile(context, params) {
      return new Promise((resolve, reject) => {
        userService.updateProfile(params)
          .then(resp => {
              resolve(resp)
          })
          .catch(err => {
              reject(err)
          })
      })
  },
  changePassword(context, params) {
      return new Promise((resolve, reject) => {
          userService.changePassword(params)
          .then(resp => {
              resolve(resp)
          })
          .catch(err => {
              reject(err)
          })
      })
  },
  getFavoriteIds(context, params){
    if (localStorage.getItem('token')) {
      return new Promise((resolve, reject) => {
          userService.getFavoriteIds(params)
          .then(resp => {
              resolve(resp)
              context.commit('set_favoriteIds',resp.data)
          })
          .catch(err => {
              reject(err)
          })
      })
    }
  }
}

// mutations
const mutations = {
    auth_success(state, response) {
      state.status = 'success'
      state.token = response.token
      state.user = response.user
    },
    auth_error(state){
      state.status = 'error'
    },
    set_user(state,response) {
      state.user = response
    },
    logout(state){
      state.status = ''
      state.token = ''
      state.user = {}
    },
    set_favorites(state, response) {
      _.forEach(response.data,function(property){
        property.property.covers = property.property.building && property.property.building.images.length > 0 ? property.property.building.images : utilsService.defaultCover()
      })
      state.favorites = response
    },
    set_favoriteIds(state, response){
      state.favoriteIds = response
    }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}